import { Paper } from "@material-ui/core";
import MaterialTable from "material-table";
import {
  FaRegBell,
  FaTimes,
  FaAmazon,
  FaPen,
  FaPowerOff,
  FaUserEdit,
  FaUserCog,
  FaRegEdit,
  FaUser,
  FaSchool,
  FaRegEnvelope,
  FaLock,
  FaKey,
  FaTrash,
  FaUsers,
} from "react-icons/fa";
import { IoCheckmarkCircle } from "react-icons/io5";

const columns = [
  {
    title: "Status",
    render: (rowData) =>
      rowData.status == true ? (
        <IoCheckmarkCircle className="mark-icon icons-effects" />
      ) : (
        <FaTimes className="mark-icon icons-effects red" />
      ),
  },
  {
    title: "First Name",
    field: "First Name",
  },
  {
    title: "Last Name",
    field: "Last Name",
  },
  {
    title: "Email",
    field: "Email",
  },
  {
    title: "Contact",
    render: (rowData) => (
      <div className="table-clmn">
        <span>{rowData.Contact}</span>
      </div>
    ),
    // field: "Contact",
  },
  {
    title: "Graduation Year",
    field: "Graduation Year",
  },
  {
    title: "Position Played",
    field: "Position Played",
  },
  {
    title: "Jersey Number",
    field: "Jersey Number",
  },
  {
    title: "Instagram Account",
    field: "Instagram Account",
  },
  {
    title: "Twitter Account",
    field: "Twitter Account",
  },
];

const CsvData = ({ data }) => {
  return (
    <div>
      <Paper>
        <MaterialTable
          style={{ textAlign: "center" }}
          title={false}
          columns={columns}
          data={data}
          options={{
            filtering: false,
            headerStyle: {
              fontFamily: "Rajdhani-Bold",
              fontSize: 14,
              backgroundColor: "#F0F8FF",
            },
            rowStyle: { fontSize: 17, fontFamily: "Rajdhani-SemiBold" },
            pageSize: 10,
            pageSizeOptions: [10, 20, 40, 60, 80, 100],
            sorting: true,
          }}
        />
      </Paper>
    </div>
  );
};

export default CsvData;
